import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column sm:flex-row-reverse xl:flex-column justify-content-between align-items-center row-gap-4" }
const _hoisted_2 = { class: "caption opacity-50 text-center" }

import DegenLayerLabel from '@/components/degenLayer/DegenLayerLabel.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Copyright',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DegenLayerLabel),
    _createElementVNode("div", _hoisted_2, " © Blueshift 2021-" + _toDisplayString(new Date().getFullYear()) + ". " + _toDisplayString(_ctx.$t('allRightsReserved')) + ". ", 1)
  ]))
}
}

})